<template>
    <div class="funnel-analytics-page-v2 layout-column noscroll">
        <div class="top_info_box justify-between">
            <div class="title">Analytics

	            <v-button flat class="try_beta_btn" @click="openIntercom()"
	                      label="Feedback!" v-tippy content="Let us know your feedback or if you have noticed any inaccuracies." />
            </div>

	        <div class="flex"></div>
	        <div class="layout-row range-wrapper">

		        <range-picker :end-date="endDate" :start-date="startDate" @reload="loadAnalytics()"
		                      :loading="loading['revenue']"
		                      :min-date="minDate" :max-date="maxDate" @rangeChanged="rangeChanged"/>

<!--		        TODO: period comparission selection -->
<!--						<span class="compare-to"> compare to </span>-->
<!--		        <range-picker :end-date="endDate" :start-date="startDate" :max-date="maxDate" @rangeChanged="rangeChanged"/>-->
	        </div>
        </div>

            <div class="main-content funnel-analytics-content scroll" style="padding: 20px 20px 60px;">

	            <filters_panel @change="loadAnalytics()" />

	            <div class="summary-container">
		            <analytics-chart title="Revenue" :prefix="currencyCode"
		                             :is-money="true" :loading="loading['revenue']"
		                             :summary="summary['revenue']" :collapsed="true" suffix=""/>

		            <analytics-chart title="Conv. Rate" prefix="" :loading="loading['unique_orders']||loading['unique_visits']"
		                             :summary="convRateSummary"
		                             :collapsed="true" suffix="%">
			            <template v-slot:info>
				            <b>Conversion Rate</b> - is calculated from the "unique orders" divided by the "unique visits",
				            giving you a more accurate estimate of the overall funnel performance.
			            </template>
		            </analytics-chart>

		            <analytics-chart title="Unique orders" prefix="" :loading="loading['unique_orders']"
		                             :summary="summary['unique_orders']" :collapsed="true" suffix="">
			            <template v-slot:info>
				            <b>Unique Orders</b> - this will count all orders made by the same customer within the
				            same session as a single order.
			            </template>

		            </analytics-chart>

		            <analytics-chart title="AOV" :prefix="currencyCode" :loading="loading['aov']"
		                             :summary="summary['aov']" :is-money="true" :collapsed="true" suffix="">
			            <template v-slot:info>
				            <b>Average Order Value</b> - is calculated by dividing the total revenue of all customers by the
				            number of unique buyers within the select time period.
			            </template>
		            </analytics-chart>

		            <analytics-chart title="Unique visits" prefix="" :loading="loading['unique_visits']"
		                             :summary="summary['unique_visits']" :collapsed="true" suffix=""/>

	            </div> <!-- Summary container -->

	            <template v-if="expandCharts">
		            <div class="layout-row flex" style="margin-top: 10px;">
			            <analytics-chart title="Revenue" :startDate="chartStart" :prefix="currencyCode"
			                             :endDate="chartEnd" :is-money="true" :loading="loading['revenue']"
			                             :summary="summary['revenue']" :is-empty="!chartsLoaded"
			                             :old-values="oldValues['revenue']" :values="values['revenue']"  />
		            </div>

		            <div class="layout-row flex" style="margin-top: 5px;">
			            <analytics-chart class="" title="Orders" :round-value="true"
			                             :loading="loading['orders']" :summary="summary['orders']"
			                             :old-values="oldValues['orders']" :values="values['orders']"
			                             :startDate="chartStart" :endDate="chartEnd" :is-empty="!chartsLoaded" />

			            <analytics-chart class="" title="AOV"  :prefix="currencyCode"
			                             :total="aov" :old-total="oldAov" :is-money="true" :summary="summary['aov']"
			                             :old-values="oldValues['aov']" :values="values['aov']"
			                             :startDate="chartStart" :endDate="chartEnd" :loading="loading['aov']"
			                             :is-empty="!chartsLoaded">
				            <template v-slot:info>
					            <b>Average Order Value</b> - is calculated by dividing the total revenue of all customers by the
					            number of unique buyers within the select time period.
				            </template>
			            </analytics-chart>
		            </div>

		            <div class="layout-row flex" style="margin-top: 5px;">
			            <analytics-chart class="" title="Unique orders" :round-value="true"
			                             :loading="loading['unique_orders']" :summary="summary['unique_orders']"
			                             :old-values="oldValues['unique_orders']" :values="values['unique_orders']"
			                             :startDate="chartStart" :endDate="chartEnd" :is-empty="!chartsLoaded"/>

			            <analytics-chart class="" title="Conv. rate"
			                             :loading="loading['unique_orders'] || loading['unique_visits']"
			                             :summary="convRateSummary" suffix="%" :round-value="false"
			                             :old-values="convRates.oldValues" :values="convRates.values"
			                             :startDate="chartStart" :endDate="chartEnd" :is-empty="!chartsLoaded"/>
		            </div>

		            <div class="layout-row flex" style="margin-top: 5px;">
			            <analytics-chart class="" title="Unique visitors" :round-value="true"
			                             :loading="loading['unique_visits']" :summary="summary['unique_visits']"
			                             :old-values="oldValues['unique_visits']" :values="values['unique_visits']"
			                             :startDate="chartStart" :endDate="chartEnd" :is-empty="!chartsLoaded"/>

			            <analytics-chart class="" title="Page views" :round-value="true"
			                             :loading="loading['pageviews']" :summary="summary['pageviews']"
			                             :old-values="oldValues['pageviews']" :values="values['pageviews']"
			                             :startDate="chartStart" :endDate="chartEnd" :is-empty="!chartsLoaded"/>
		            </div>
	            </template> <!-- expandCharts -->

	            <div class="expand-charts-btn" :ref="`expandChartsBtn_${instanceId}`" :class="{'open':expandCharts}">
		            <v-button v-show="expandCharts" flat slim @click="expandChartsChanged()" v-tippy="{theme:'small-black'}"
		                      content="Hide detailed charts"
		                      :icon="require('@/assets/img/chevron-double-down.svg')" />
		            <v-button v-show="!expandCharts" flat slim @click="expandChartsChanged()" v-tippy="{theme:'small-black'}"
		                      content="Show detailed charts"
		                      :icon="require('@/assets/img/chevron-double-down.svg')" />
		            <div class="flex"></div>
	            </div>

	            <div class="performance-breakdown noscroll" style="height: auto;margin-top: 50px;">
                <div class="layout-row flex">
	                <h2>Performance breakdown</h2>
	                <div class="flex"></div>
	                <v-switch class="expand-all" label="Expand all"
	                          v-model="expandAll" :value="expandAll" @change="expandAllChanged" />
                </div>
                <div class="analytics-table-container scroll" ref="analyticsContainer"
                     style="position: relative;">
                    <Loading v-show="loadingSteps"/>
                    <table  class="analytics-table table-analitics">
                      <tbody>
                      <thead>
                      <tr>
                        <th>
	                        <div class="th-wrap">
		                        Step
	                        </div>
                        </th>
                        <th class="conv-rate-td">
	                        <div class="th-wrap">
		                        Conv. rate
	                        </div>
                        </th>
                        <th>
	                        <div class="th-wrap">
		                        Revenue
	                        </div>
                        </th>
                        <th>
	                        <div class="th-wrap">
		                        Orders
	                        </div>
                        </th>
                        <th>
	                        <div class="th-wrap">
		                        Uniq. visits
	                        </div>
                        </th>
                        <th>
	                        <div class="th-wrap">
		                        Page views
	                        </div>
                        </th>
                        <th class="__downstream">
	                        <div class="th-wrap">
		                        Downstream Revenue
		                        <info-icon small theme="small-black" info="<b>Downstream Revenue:</b> A Good indicator of the quality of traffic driven by each step/page. Calculates the total revenue of subsequent steps from customers that have gone through the current step/page." />
	                        </div>
                        </th>
                        <th class="__downstream">
	                        <div class="th-wrap">
		                        Downstream Orders
	                        </div>
                        </th>
                      </tr>
                      </thead>
                      <template v-for="(step, index) in visibleSteps">

                        <analytics-step-v2 :step="step" :start-date="startDate" :end-date="endDate" :old-end-date="oldEndDate" :old-start-date="oldStartDate"
                                           :get-conditions="getConditions" :loading-steps="loadingSteps"
                                           :show-pages="expandAll" />
                      </template>

                      <template v-if="showDeletedSteps" v-for="(step, index) in deletedSteps">
                        <analytics-step-v2 :step="step" :loading-steps="loadingSteps" />
                      </template>
<!--<StepAnalyticsRowV2 :step="step" v-for="(step, index) in sortedSteps"-->
<!--                    @click="$set(step,'hidePages',!step.hidePages)" :open="!step.hidePages" />-->

                      </tbody>
                    </table>

                  <div v-if="deletedSteps.length>0" class="sticky-bottom-btn" :class="{'open':showDeletedSteps}">
                    <v-button flat slim @click="showDeletedSteps=!showDeletedSteps"
                              :label="`${showDeletedSteps?'hide':'show'} deleted steps`"
                              :icon="require('@/assets/img/arrow-bottom.svg')" />
                    <div class="flex"></div>
                  </div>

                </div>
              </div>

	            <div class="layout-column flex-center">
		            <p class="alert_box blue">
			            <inline-svg class="icon" :src="require('@/assets/img/info_icon.svg')" />
			            Your feedback helps us improve, let us know about any missing metrics or inaccuracies.
		            </p>
	            </div>
            </div>
    </div>
</template>

<script>

import API from "@/api"
import {mapGetters} from "vuex"
import Loading from "@/components/Loading.vue"
import {getSymbol} from "@/helpers/currencies";
import Chart from "@/components/base/chart";
const moment = require('moment-timezone');
import RangePicker from "@/components/base/range-picker";
import analytics, {percentage} from "@/helpers/analytics";
import StepAnalyticsRow from "@/views/funnels/funnel-plus/funnel/analytics/step_analytics_row";
import PageAnalyticsRow from "@/views/funnels/funnel-plus/funnel/analytics/page_analytics_row";
import AnalyticsStep from "@/views/funnels/funnel-plus/funnel/analytics/analytics-step";
import VButton from "@/components/base/v-button";
import TimezonePopup from "@/components/popups/timezone-popup";
import Filters_panel from "@/views/funnels/funnel-plus/funnel/analytics/filters_panel";
import AnalyticsChart from "@/views/funnels/funnel-plus/funnel/analytics/analytics-chart";
import AnalyticsStepV2 from "@/views/funnels/funnel-plus/funnel/analytics/analytics-step.v2";
import {sortItems} from "@/helpers/sort";
import VSwitch from "@/components/base/v-switch";
import InfoIcon from "@/components/base/info-icon";
let id = 1;
export default {
    name: "Analytics",
    components: {
	    InfoIcon,
	    VSwitch,
	    AnalyticsStepV2,
	    AnalyticsChart,
	    Filters_panel,
	    TimezonePopup,
	    VButton,
	    AnalyticsStep,
	    PageAnalyticsRow,
	    StepAnalyticsRow,
	    RangePicker,
	    Chart,
      Loading
    },
    mixins: [API],
    props: ['id'],
    data() {
	    return {
	    	  instanceId: id++,
	        unit: "day",
        	maxDate: new Date(),
	        startDate: new Date(),
	        endDate: new Date(),
		      currentRange: 'Last 30 days',
			    expandAll: false,
			    expandCharts: false,
			    chartsLoaded: false,

		      showDeletedSteps: false,

	        // Purchase values
	        purchaseValue: 0,
	        oldPurchaseValue: 0,
	        purchaseValues: [{value:0},{value:0}],
	        oldPurchaseValues: [{value:0},{value:0}],

	        // Purchases
	        purchases: 0,
	        oldPurchases: 0,
	        purchasesData: [{value:0},{value:0}],
	        oldPurchasesData: [{value:0},{value:0}],

		    // AOV
		    aov: 0,
		    oldAov: 0,
		    aovData: [{value:0},{value:0}],
		    oldAovData: [{value:0},{value:0}],

		    // Conv. rate
	        convRate: 0,
	        oldConvRate: 0,
	        // convRates: [{value:0},{value:0}],
	        oldConvRates: [{value:0},{value:0}],

	        // Visitors
	        visitors: 0,
	        oldVisitors: 0,
	        visitorsData: [{value:0},{value:0}],
	        oldVisitorsData: [{value:0},{value:0}],

	        // Optins
	        optins: 0,
	        oldOptins: 0,
	        optinsData: [{value:0},{value:0}],
	        oldOptinsData: [{value:0},{value:0}],

	        // Optin rate
	        optinRate: 0,
	        oldOptinRate: 0,
	        optinRates: [{value:0},{value:0}],
	        oldOptinRates: [{value:0},{value:0}],

					steps: [],

		    loading: {
			    'revenue':true,
			    'optins':true,
			    'orders':true,
			    'pageviews':true,
			    'unique_visits': true,
			    'unique_orders': true,
		    },
		    values:{
			    'revenue':[],
			    'orders':[],
			    'optins':[],
			    'pageviews':[],
			    'unique_visits': [],
			    'unique_orders':[],
		    },
		    summary:{
			    'revenue': {},
			    'orders': {},
			    'optins': {},
			    'pageviews': {},
			    'unique_visits': {},
			    'unique_orders':{},
		    },
		    oldValues:{
			    'revenue':[
				    {date:moment(),value:0}
			    ],
			    'orders':[
				    {date:moment(),value:0}
			    ],
			    'pageviews':[
				    {date:moment(),value:0}
			    ],
			    'unique_orders':[
				    {date:moment(),value:0}
			    ],
			    'unique_visits':[
				    {date:moment(),value:0}
			    ],
		    },
		    loadingSteps: true,
          funnel: {},
        }
    },
    computed: {
        ...mapGetters(["getFunnelStore",]),
	    currencyCode() {
		    let currency = this.getFunnelStore.currency_code;
		    return getSymbol(currency);
	    },
	    convRateSummary() {

		    return {
			    value: Math.max(0, Math.min(percentage(this.summary['unique_orders'].value, this.summary['unique_visits'].value), 100)),
			    old_value: Math.max(0, Math.min(percentage(this.summary['unique_orders'].old_value, this.summary['unique_visits'].old_value), 100))
		    }
	    },
	    sortedSteps(){
        	return sortItems(this.steps)
	    },
	    visibleSteps(){
		    return sortItems(this.steps.filter(s=>!s.is_deleted))
	    },
	    deletedSteps(){
		    return sortItems(this.steps.filter(s=>s.is_deleted))
	    },
	    chartStart() {
		    return analytics.formatChartDate(this.unit,this.startDate);
	    },
	    oldStartDate() {
		    if (this.unit==="hour") {
			    let days = moment(this.endDate).diff(this.startDate, "hours")+1;
			    let start = moment(this.startDate).subtract(days, "hours").startOf('day');

			    return start;
		    } else {
			    let days = moment(this.endDate).diff(this.startDate, "days")+1;
			    let start = moment(this.startDate).subtract(days, "days").startOf('day');

			    return start;
		    }
	    },
	    chartEnd() {
		    return analytics.formatChartDate(this.unit, this.endDate);
	    },
	    oldEndDate() {
		    if (this.unit==="hour") {
			    let end = moment(this.startDate).subtract(1, "hours").endOf('day');
			    return end;
		    } else {
			    let end = moment(this.startDate).subtract(1, "days").endOf('day');
			    return end;
		    }
	    },
	    minDate() {
		    return moment(this.getFunnelStore.created_at);
	    },
	    convRates() {
		    return {
			    values: this.calcRates(this.values['unique_orders'], this.values['unique_visits']),
			    oldValues: this.calcRates(this.oldValues['unique_orders'], this.oldValues['unique_visits'])
		    }
	    }
    },
    methods: {
	    calcRates(orders,visits) {
		    let rates = [];
		    visits.forEach(v => {
			    let vDate = moment(v.date);
			    let order = orders.find(o=>moment(o.date).isSame(vDate))
			    if (!order) return
			    let per = this.percentage(order.value, v.value)
			    rates.push({date:v.date,brief:v.brief,value:per})
		    })
		    return rates;
	    },
	    hiddenPages(pages) {
		    return pages.filter(x => x.is_deleted)
	    },
	    visiblePages(pages) {
		    return pages.filter(x => !x.is_deleted)
	    },
    	percentage(sub,total) {
    		return percentage(sub,total)
	    },
	    rangeChanged(currentRange, startDate, endDate) {
		    this.startDate = startDate;
		    this.endDate = endDate;
		    this.currentRange = currentRange;

		    this.storeRange();

	    	this.loadAnalytics();
	    },
	    storeRange() {
		    analytics.storeRange(this.currentRange, this.startDate, this.endDate);
	    },
	    loadRange() {
		    let {currentRange, startDate, endDate} = analytics.loadRange();

		    this.currentRange = currentRange;
		    this.endDate = endDate;
		    this.startDate = startDate;
	    },
	    getConditions() {
		    let s = localStorage.getItem("filterConditions")
		    if (s) {
			    try {
				    return JSON.parse(s)
			    } catch (e) {
				    console.warn(e)
			    }
		    }
		    return []
	    },
	    reload() {
		    try {

			    this.loadChart('revenue')
			    this.loadChart('orders')
			    this.loadChart('aov')
			    this.loadChart('pageviews')
			    this.loadChart('unique_visits')
			    this.loadChart('unique_orders')

		    } catch (e) {
			    console.error(e)
		    } finally {
		    }
	    },
	    openIntercom() {
		    window.Intercom("showNewMessage", "Funnel analytics feedback:\n");
	    },
	    async loadChart(chart='revenue') {
		    try {
			    this.loading[chart] = true;

			    // load only if charts are expanded
			    if (this.expandCharts) {
				    let id = this.$route.params.id;
				    let data = await this.api.analytics.getTrends_v2(chart, id, this.startDate, this.endDate, this.unit, this.getConditions());
				    let data2 = await this.api.analytics.getTrends_v2(chart, id, this.oldStartDate, this.oldEndDate, this.unit, this.getConditions());
				    // console.log('loadChart', this.startDate, this.endDate)

				    this.values[chart] = this.getDataFromTrends(this.unit, data, this.startDate, this.endDate)
				    this.oldValues[chart] = this.getDataFromTrends(this.unit, data2, this.oldStartDate, this.oldEndDate)

				    this.chartsLoaded = true;
			    } else {
				    this.chartsLoaded = false;
			    }

			    await this.loadSummary(chart)
		    } catch (e) {
			    console.error(e)
		    } finally {
			    this.loading[chart] = false;
		    }
	    },
	    async loadSummary(chart='revenue') {
		    try {
			    this.loading[chart] = true;
			    let id = this.$route.params.id;
			    let data = await this.api.analytics.getSummary_v2(chart, id,
					    this.startDate, this.endDate, this.oldStartDate, this.oldEndDate, this.getConditions());

			    this.summary[chart] = data;

			    // this.values[chart] = data
		    } catch (e) {
			    console.error(e)
		    } finally {
			    this.loading[chart] = false;
		    }
	    },
	    getDataFromTrends(unit, trends, startDate, endDate) {
		    let data = [];

		    let date = moment(startDate).add(1, 'hour').startOf('day');

		    // take min date either NOW or endDate.
		    let endD = moment.min([endDate, moment()]);

		    if (!trends || trends.length === 0) {
			    data = [{value: 0, date: date, brief: this.unitToBrief(unit, date.unix())}, {
				    value: 0, date: endD, brief: this.unitToBrief(unit, endD.unix())
			    }];
		    } else {
			    for (let i = 0; i < trends.length; i++) {
				    let t = trends[i];

				    data.push({
					    value: t.value,
					    brief: this.unitToBrief(unit, t.date),
					    date: moment.unix(t.date),
					    // day: t.day,
					    // month: t.month,
					    // week: t.week,
					    // year: t.year, // date: t.date,
					    // hour: t.hour,
				    })
			    }
		    }
		    this.cleanData(unit, data, startDate, endDate);
		    return data;
	    },
	    // Adds missing days...
	    cleanData(unit, data, startDate, endDate) {

		    // cap endDate to today.
		    if (moment().diff(endDate, "hours") < 0) endDate = moment()
		    if (moment().diff(startDate, "hours") < 0) startDate = moment()

		    let unitsDiff = Math.abs(moment(endDate).diff(startDate, unit)) + 1;

		    // console.log('cleanData', unitsDiff, startDate, endDate, unit)

		    for (let i = 0; i < unitsDiff; i++) {
			    let date = moment(startDate).add(i, unit);
			    let entry = this.findEntryInData(date, data, unit);

			    if (!entry) {
				    data.splice(i, 0, {value: 0, date: date, brief: this.unitToBrief(unit, date.unix())})
			    }
		    }
	    },
	    findEntryInData(date, data, unit) {
		    for (let i = 0; i < data.length; i++) {
			    if (moment(data[i].date).isSame(date, unit+"s")) {
				    return data[i];
			    }
		    }
		    return null;
	    },
	    unitToBrief(unit, date)  {
		    let newDate = moment.unix(date);
		    switch (unit) {
			    case "week": {
				    let from_date = newDate.startOf('week');
				    let to_date = newDate.endOf('week');
				    return from_date.format("DD MMM") + " - " + to_date.format("DD MMM");
			    }
			    case "month":
				    return newDate.format("MMM YYYY");
			    case "hour": {
				    if (moment().isSame(newDate, "day")) {
					    return "Today - "+newDate.format("HH:00");
				    } else if (moment().subtract(1, "days").isSame(newDate, "day")) {
					    return "Yesterday - "+newDate.format("HH:00");
				    }
				    return newDate.format("ddd DD - HH:00");
			    }
			    default:
				    return newDate.utcOffset(0,false).format("DD MMM")
		    }
	    },
	    async loadCharts(unit) {
	    	try {
	    		this.loading = true;
			    let id = this.$route.params.id;
			    let data = await this.api.analytics.get(id, this.startDate, this.endDate, unit, this.oldStartDate, this.oldEndDate);

			    // Purchase values
			    this.purchaseValue = data.revenue;
			    this.purchaseValues = analytics.getDataFromTrends(this.unit, data.trends, "revenue", this.startDate, this.endDate)
			    this.oldPurchaseValue = data.old_revenue;
			    this.oldPurchaseValues = analytics.getDataFromTrends(this.unit, data.old_trends, "revenue", this.oldStartDate, this.oldEndDate)

			    // Purchases
			    this.purchases = data.orders;
			    this.purchasesData = analytics.getDataFromTrends(this.unit, data.trends, "orders", this.startDate, this.endDate)
			    this.oldPurchases = data.old_orders;
			    this.oldPurchasesData = analytics.getDataFromTrends(this.unit, data.old_trends, "orders", this.oldStartDate, this.oldEndDate)

			    // AOV
			    this.aov = data.aov;
			    this.aovData = analytics.getDataFromTrends(this.unit, data.trends, "aov", this.startDate, this.endDate)
			    this.oldAov = data.old_aov;
			    this.oldAovData = analytics.getDataFromTrends(this.unit, data.old_trends, "aov", this.oldStartDate, this.oldEndDate)

			    // Visitors
			    this.visitors = data.visits;
			    this.oldVisitors = data.old_visits;

			    if (unit === "hour") {  // handle hourly data differently
				    this.visitorsData = analytics.getDataFromTrends(this.unit, data.hourly_visits, "visits", this.startDate, this.endDate)
				    this.oldVisitorsData = analytics.getDataFromTrends(this.unit, data.old_hourly_visits, "visits", this.oldStartDate, this.oldEndDate)
			    } else {
				    this.visitorsData = analytics.getDataFromTrends(this.unit, data.trends, "visits", this.startDate, this.endDate)
				    this.oldVisitorsData = analytics.getDataFromTrends(this.unit, data.old_trends, "visits", this.oldStartDate, this.oldEndDate)
			    }

			    // Optins
			    this.optins = data.optins;
			    this.optinsData = analytics.getDataFromTrends(this.unit, data.trends, "optins", this.startDate, this.endDate)
			    this.oldOptins = data.old_optins;
			    this.oldOptinsData = analytics.getDataFromTrends(this.unit, data.old_trends, "optins", this.oldStartDate, this.oldEndDate)

			    // Conversion rates
			    this.convRate = percentage(this.purchases, this.visitors);
			    this.convRates = analytics.generateRates(this.visitorsData, this.purchasesData);
			    this.oldConvRate = percentage(this.oldPurchases, this.oldVisitors);
			    this.oldConvRates = analytics.generateRates(this.oldVisitorsData, this.oldPurchasesData);

			    // Optin rates
			    this.optinRate = percentage(this.optins, this.visitors);
			    this.optinRates = analytics.generateRates(this.visitorsData, this.optinsData);
			    this.oldOptinRate = percentage(this.oldOptins, this.oldVisitors);
			    this.oldOptinRates = analytics.generateRates(this.oldVisitorsData, this.oldOptinsData);
		    }catch (e) {
			    console.error(e);
		    } finally {
			    this.loading = false;
		    }
	    },
	    async loadPerfBreakdown(unit) {
		    try {
		    	this.loadingSteps = true;
			    let id = this.$route.params.id;
			    let data = await this.api.analytics.getBreakdownV2(id, this.startDate, this.endDate, this.getConditions());
		    	this.steps = data;

		    } catch (e) {
			    this.steps = [];
			    console.error(e);
		    } finally {
			    this.loadingSteps = false;
		    }
	    },
	    async loadAnalytics() {
    		try {
			    let unit = "day";
			    let days = Math.abs(moment(this.endDate).diff(this.startDate, "days"))+1;
			    if (days > 6*30) {
			    	unit = "month";
			    } else if (days > 31) {
				    unit = "week";
			    } else if (days <= 2) {
				    unit = "hour"
			    }

			    this.unit = unit;

			    // this.loadCharts(unit); // async

			    this.reload()

			    this.loadPerfBreakdown(unit); // async
		    } catch (e) {
			    this.$error(e)
		    }
	    },

	    expandAllChanged() {
		    localStorage.setItem('funnelAnalyticsExpandAll', this.expandAll.toString())
	    },
	    expandChartsChanged() {
				this.$set(this, "expandCharts", !this.expandCharts)

		    localStorage.setItem('funnelAnalyticsExpandCharts', this.expandCharts.toString())

		    if (this.expandCharts && !this.chartsLoaded) {this.reload()} // reload charts only, if haven't been loaded already.
	    },
    },

	mounted() {
    	let c = this.$refs['analyticsContainer']
		c.addEventListener('scroll', e => {
			if (c.scrollLeft>0) c.classList.add('scrolled')
			else c.classList.remove('scrolled')
		})
		let expandCharts = this.$refs[`expandChartsBtn_${this.instanceId}`]
		let btns = expandCharts.querySelectorAll('.button');
		btns.forEach(btn=>{
			btn.addEventListener('hover', e=>{
				btn.closest('.expand-charts-btn').classList.add('hovered')
			})
			btn.addEventListener('mouseenter', e=>{
				btn.closest('.expand-charts-btn').classList.add('hovered')
			})
			btn.addEventListener('mouseleave', e=>{
				btn.closest('.expand-charts-btn').classList.remove('hovered')
			});
		})

		this.loadAnalytics();

	},
	created() {
		this.loadRange();

		let expandAll = localStorage.getItem('funnelAnalyticsExpandAll')
		this.expandAll = (expandAll === 'true')
		let expandCharts = localStorage.getItem('funnelAnalyticsExpandCharts')
		this.expandCharts = (expandCharts === 'true')

  }
}
</script>
<style lang="scss" scoped>
.summary-container {
	margin-top: 20px;
	width: 100%;
	overflow: hidden;
	display: grid;
	grid-gap: 20px;
	grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
}
.title .tag {
	background: #fff3f3;
	border-radius: 4px;
	font-size: 12px;
	color: #FB595B !important;
	padding: 3px 5px;
	position: relative;
	top: -8px;
	left: 5px;
}
.range-wrapper {
	display: flex;
	flex-direction: row;
	align-items: center;

	.compare-to {
		margin: 0 10px;
	}
}
</style>

<style lang="scss" >
.funnel-analytics-page-v2 .top_info_box .title {
	display: flex;
	flex-direction: row;
	align-items: center;
	.try_beta_btn {
		margin-left: 20px;
		border-radius: 30px;
		border: 1px solid $blue;
		background: $light-blue;
		padding: 3px 15px;
		font-size: 12px;
		&:hover {
			background: $hover-light-blue;
		}
		.label {
			color: $blue;
		}
		svg, svg path {
			fill: $blue;
		}
	}
}

th.__downstream {
	text-align: right;
}
.funnel-analytics-content {
	.expand-all .switch {
		display: flex;
		flex-direction: row-reverse;
		.switch_checkbox {
			margin-right: 0;
			margin-left: 10px;
		}
		.text_label {
			color: $dark-grey;
		}
	}
	.expand-charts-btn {
		display: flex;
		flex: 1;
		margin-top: 10px;
		margin-bottom: 20px;
		position: relative;
		height: 50px;

		&::before {
			content: "";
			display: flex;
			width: 100%;
			height: 1px;
			position: absolute;
			top: calc(50% - 1px);
			background: grey;
			background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(194,194,194,1) 50%, rgba(255,255,255,1) 100%);
			transition: all 200ms ease-in-out;
			border-radius: 4px;
		}
		&.hovered {
			&::before {
				background: linear-gradient(90deg, rgb(245, 245, 245) 0%, rgba(194,194,194,1) 50%, rgb(245, 245, 245) 100%);
				box-shadow: 0 0 0 5px whitesmoke;
			}
		}
		.button {
			z-index: 2;
			border: 1px solid $light-grey;
			border-radius: 30px;
			height: 30px;
			width: 40px;
			background: white;
			position: absolute;
			left: calc(50% - 20px);
			top: calc(50% - 15px);
			transition: all 200ms ease-in-out;

			&:hover {
				background: whitesmoke;
				box-shadow: 0 0 0 5px whitesmoke;
				svg path {
					fill: $dark-grey;
				}
			}
			svg {
				height: 30px;
				width: 30px;
				position: absolute;
				top: calc(50% - 15px);
				left: calc(50% - 15px);
				path {
					fill: $grey;
				}
			}
		}
		&.open {
			.button {
				svg {
					transform: rotate(180deg);
				}
			}
		}
	}
	.sticky-bottom-btn {
		display: flex;
		flex-direction: row;
		position: sticky;
		left: 10px;
		margin-top: 10px;
		bottom: 20px;

		&.open {
			.button {
				svg {
					transform: rotate(180deg);
				}
			}
		}
	}
}
    .performance-breakdown {
      .analytics-table-container {
        overflow-x: scroll;
        overflow-x: overlay;

	      .loading {
		      background: rgba(196, 196, 196, 0.19);
	      }
	      &.scrolled {
		      td:first-child, th:first-child {
			      border-right: none;
			      //position: relative;
			      &:after {
				      content: "";
				      display: flex;
				      height: 100%;
				      width: 1px;
				      top: 0;
				      right: 0;
				      position: absolute;
				      box-shadow: 1px 0 3px rgba(0, 0, 0, 0.19), 4px 0 5px rgba(0, 0, 0, 0.2), 5px 0 10px rgba(0, 0, 0, 0.28);
				      background: rgba(173, 173, 173, 0.36);
			      }
		      }
	      }
      }
        h2 {
            font-weight: 500;
            font-size: 18px;
            line-height: 150%;
            letter-spacing: 0.02em;
            color: #252A32;
            margin-bottom: 30px;
        }
        .step-name {
            a:hover {
                strong {
                    color: #4268e0;
                }
            }
        }

        .deleted {
            .step-name {
                .name {
                    color: #c6c6c6;
                }
            }
        }
    }

</style>
